export enum NotificationTypesEnum {
    submission_request = "submission_request",
    submission_response = "submission_response",
    milestone_output_audit_request = "milestone_output_audit_request",
    milestone_output_audit_response = "milestone_output_audit_response",
    outcome_proof_audit_request = "outcome_proof_audit_request",
    outcome_proof_audit_response = "outcome_proof_audit_response",
    project_execution_stop = "project_execution_stop",
    project_execution_resume = "project_execution_resume",
    project_chat_message = "project_chat_message",
    milestone_due_reminder = "milestone_due_reminder",
    approval_message = "approval_message",
    SectionAdminApproved = "SectionAdminApproved",
    SectionAdminReject = "SectionAdminReject",
    DepartmentAdminApproved = "DepartmentAdminApproved",
    DepartmentAdminReject = "DepartmentAdminReject",
    SectorAdminReject = "SectorAdminReject",
    SectorAdminApproved = "SectorAdminApproved",
};

export enum NotificationActionsEnum {
    "sendSubmissionRequest" = "sendSubmissionRequest",
};

export interface INotification {
    id: number,
    metaData: any,
    strategic_plan_id: number,
    sender_id: number,
    receiver_id: number,
    data: any,
    header: string,
    type: string,
    is_read: boolean,

    sender_name: string,
    receiver_name: string,

    url: string,

    created_at: number,
    updated_at: number,
    deleted_at: number,
    is_deleted: boolean,
};

export interface ISentNotification extends Partial<INotification> {
    receiverIds: number[],
    locale: 'ar' | 'en',
}